<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen">
    <div
        class="flex justify-between divide-x-1.5 bg-white mx-3 mb-5 mt-10 items-center overflow-x-auto md:overflow-hidden"
    >
      <div
          v-for="(menu, index) in subMenus"
          :key="index"
          @click="setSelectedMenu(menu.name)"
      :class="{
      'bg-primary text-white': selectedSubMenu === menu.name,
      }"
      class="text-sm text-center w-full font-semibold hover:bg-primary hover:text-white cursor-pointer p-3"
      >
      {{ menu.name }}
    </div>
  </div>

  <directory v-if="selectedSubMenu === 'Directory'"></directory>
  <organogram v-if="selectedSubMenu === 'Organogram'"></organogram>
  <structure v-if="selectedSubMenu === 'Structure'"></structure>
  <work-hours v-if="selectedSubMenu === 'Work Hours'"></work-hours>
  <knowledge-base v-if="selectedSubMenu === 'Knowledge Base'"></knowledge-base>
  <holidays v-if="selectedSubMenu === 'Holidays'"></holidays>
  </div>
</template>

<script>
import Directory from "@/components/company/directory.vue";
import Organogram from "@/components/company/organogram.vue";
import Structure from "@/components/company/structure.vue";
import WorkHours from "@/components/company/workHours/workHours.vue";
import KnowledgeBase from "@/components/company/knowledgeBase.vue";
import Holidays from "@/components/company/holidays.vue";

export default {
  name: "Company",
  components: {
    Directory,
    Organogram,
    Structure,
    WorkHours,
    KnowledgeBase,
    Holidays,
  },
  data() {
    return {
      selectedSubMenu: "Directory", // Set initial tab to "Directory"
      subMenus: [
        { name: "Directory", route: "directory" },
        { name: "Organogram", route: "organogram" },
        { name: "Structure", route: "structure" },
      /*  { name: "Work Hours", route: "workhours" },*/
        { name: "Knowledge Base", route: "knowledgebase" },
        { name: "Holidays", route: "holidays" },
      ],
    };
  },
  methods: {
    // Method to update the selected tab
    setSelectedMenu(menuName) {
      this.selectedSubMenu = menuName;
    },
  },
};
</script>

<style scoped>
.bg-primary {
  background-color: #dea42c; /* Adjust to your preferred primary color */
}
.text-white {
  color: white;
}
</style>
